module.exports = __webpack_public_path__ + "img/sl_slider3.dbf0d719.png";